<template>
  <div class="header">
    <div style="float:left;width:70%">
    <img @click="$router.push('juka')" src="~assets/images/logo.png"></div>
    <a @click="$router.push('mjuka')">个人中心<i class="el-icon-arrow-right"></i></a>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        userjwt:''
      }
    },
    mounted() {
      if(localStorage.getItem('userjwt') != null){
        this.userjwt = localStorage.getItem('userjwt');
      }
    },
    methods: {
      tz:function(url){
        location.replace(url)
      },
    },
  }
</script>


<style>
  .header{
    width:100%;
    height:36px;
    background:#fff;
    font-size:14px;
    color:#646566;
    line-height:36px;
    top:0;
    left:0;
    position:fixed;
    z-index:99
  }
  .header img{
    height:36px;
    background:#fff;
    float:left;
    margin:0px 8px 0 2px
  }
  .header a{
    float:right;
    margin-right:8px
  }
</style>
